import React, { ReactElement } from 'react';
import styles from './CloudInformation.module.less';
import CcxComponentProps from '../../../core/CcxComponent';
import DeploymentsItem from '../../../types/DeploymentsItem';
import AppFlagIcon from '../../ccx/common/AppFlagIcon';
import AppLogoBrandAws from '../../ccx/common/AppLogoBrandAws';
import AppLogoBrandCityCloud from '../../ccx/common/AppLogoBrandCityCloud';
import AppLogoBrandGoogleCloud from '../../ccx/common/AppLogoBrandGoogleCloud';
import AppLogoBrandSafespring from '../../ccx/common/AppLogoBrandSafespring';
import SmallContainer from '../../ccx/common/SmallContainer';
import CloudProvider from '../../../types/CloudProvider';
import AppLogoBrandVultr from '../../ccx/common/AppLogoBrandVultr';
import AppLogoBrandLintasarta from '../../ccx/common/AppLogoBrandLintasarta';
import AppLogoBrandElastx from '../../ccx/common/AppLogoBrandElastx';
import AppLogoBrandSyseleven from '../../ccx/common/AppLogoBrandSyseleven';

interface Props extends CcxComponentProps {
    countryCode: string;
    dataStore: DeploymentsItem;
}

function CloudInformation({
    countryCode,
    dataStore,
    testId = 'CloudInformation',
}: Props): ReactElement {
    const getCloudProviderLogo = (p: CloudProvider) => {
        if (p.isAws())
            return (
                <AppLogoBrandAws useExtended={true} height={20} width={20} />
            );
        if (p.isSafespring())
            return (
                <AppLogoBrandSafespring
                    useExtended={false}
                    height={16}
                    width={16}
                />
            );
        if (p.isCityCloud())
            return (
                <AppLogoBrandCityCloud
                    useExtended={false}
                    height={17}
                    width={18}
                />
            );
        if (p.isGoogle())
            return (
                <AppLogoBrandGoogleCloud
                    useExtended={false}
                    height={16}
                    width={16}
                />
            );
        if (p.isVultr())
            return (
                <AppLogoBrandVultr useExtended={false} height={20} width={20} />
            );
        if (p.isLintasarta())
            return (
                <AppLogoBrandLintasarta
                    useExtended={true}
                    height={20}
                    width={20}
                />
            );
        if (p.isElastx())
            return (
                <AppLogoBrandElastx
                    useExtended={false}
                    height={20}
                    width={20}
                />
            );
        if (p.isSyseleven())
            return (
                <AppLogoBrandSyseleven
                    useExtended={false}
                    height={15}
                    width={24}
                />
            );

        return null;
    };

    const top = (
        <>
            {getCloudProviderLogo(dataStore.getCloudProvider())}
            <div>{dataStore.getFullCloudProviderName()}</div>
        </>
    );
    const middle = (
        <>
            <AppFlagIcon code={countryCode} />
            <div>
                {dataStore?.isLintasarta()
                    ? dataStore?.preferredRegion
                    : dataStore?.cloudRegion}
            </div>
        </>
    );

    return (
        <SmallContainer
            testId={testId}
            topChildren={top}
            middleChildren={middle}
        />
    );
}

export default CloudInformation;
